export const ADD_LABELS_TO_ARTICLE_FAILURE =
	'state.actions.add-labels-to-article-failure.ADD_LABELS_TO_ARTICLE_FAILURE';

export type AddLabelsToArticleFailure = {
	articleId: string;
};

export type AddLabelsToArticleFailureAction = {
	type: typeof ADD_LABELS_TO_ARTICLE_FAILURE;
	payload: AddLabelsToArticleFailure;
};

export const addLabelsToArticleFailure = (
	payload: AddLabelsToArticleFailure,
): AddLabelsToArticleFailureAction => ({
	payload,
	type: ADD_LABELS_TO_ARTICLE_FAILURE,
});
